module.exports = __webpack_public_path__ + "static/media/aeronave.376a528d.glb";